import React, { useEffect } from 'react';
import { PaymentElement, useElements } from '@stripe/react-stripe-js';
import { StripeElements } from '@stripe/stripe-js';

interface WrappedPaymentElementProps {
  onElementsLoaded: (elements: StripeElements) => void,
}

function WrappedPaymentElement({ onElementsLoaded }: WrappedPaymentElementProps) {
  const elements = useElements();

  useEffect(() => {
    if (elements) {
      onElementsLoaded(elements);
    }
  }, [elements]);

  return <PaymentElement options={{ fields: { billingDetails: { address: 'never' } } }} />;
}

export default WrappedPaymentElement;
